<template>
  <!-- <div class="banner" style="margin-bottom: 20px;">
    <div v-if="$i18n.locale === 'zh'">
        <a target="_blank" href="http://www.dalianriyou.com/"><img src="https://register.b-china.cn/banner/banner1zh.jpg"></a>
        <img src="https://register.b-china.cn/banner/banner2zh.jpg">
      </div>
      <div v-else>
        <a target="_blank" href="http://www.dalianriyou.com/"><img src="https://register.b-china.cn/banner/banner1zh.jpg"></a>
        <img src="https://register.b-china.cn/banner/banner2zh.jpg">
      </div>
  </div> -->
  <div class="carousel">
    <div
      class="carousel-slide"
      :style="{ transform: `translateX(-${currentSlide * 100}%)` }"
    >
      <div class="carousel-item" v-for="(slide, index) in slides" :key="index">
        <img :src="slide.image" :alt="slide.alt" @click="gosrc(slide)" />
      </div>
    </div>
    <!-- 轮播图按钮 -->
    <button @click="prevSlide" class="carousel-button prev-button">‹</button>
    <button @click="nextSlide" class="carousel-button next-button">›</button>
    <!-- 轮播图指示点 -->
    <div class="carousel-indicators">
      <span
        v-for="(slide, index) in slides"
        :key="index"
        :class="{ active: index === currentSlide }"
        @click="goToSlide(index)"
      ></span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentSlide: 0,
      slides: [],
    };
  },
  methods: {
    gosrc(e) {
      if (e.src) {
        window.open(e.src)
      }
    },
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.slides.length;
    },
    prevSlide() {
      this.currentSlide =
        (this.currentSlide - 1 + this.slides.length) % this.slides.length;
    },
    goToSlide(index) {
      this.currentSlide = index;
    },
    shuffleArray() {
      let array =   
        [ 
          { image: "https://register.b-china.cn/banner/banner1.jpg", alt: "Slide 1",src:"https://www.makinebirlik.com/En" },
          { image: "https://register.b-china.cn/banner/banner2.jpg", alt: "Slide 2",src:"https://mp.weixin.qq.com/s/kARV7z-qmGvbwHhjdfdKPg" },
          { image: "https://register.b-china.cn/banner/banner3.jpg", alt: "Slide 2",src:"http://www.coppern.net/" },
        ]
      for (let i = array.length - 1; i > 0; i--) {
        // 从数组中随机挑选一个索引
        const j = Math.floor(Math.random() * (i + 1));
        // 交换元素
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    }
  },
  mounted() {
    setInterval(this.nextSlide, 3000); // 每3秒切换下一张
    this.slides = this.shuffleArray();
  },
};
</script>

<style scoped>
.carousel {
  position: relative;
  overflow: hidden;
  margin: auto;
}
.carousel-slide {
  display: flex;
  transition: transform 0.5s ease;
}
.carousel-item {
  min-width: 100%;
  height: 100%;
}
.carousel-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}
.carousel-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
  font-size: 24px;
}
.prev-button {
  left: 10px;
}
.next-button {
  right: 10px;
}
.carousel-indicators {
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 5px;
}
.carousel-indicators span {
  width: 10px;
  height: 10px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  cursor: pointer;
}
.carousel-indicators .active {
  background-color: white;
}
</style>